var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcon0 = function SvgIcon0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 22a8 8 0 0 1 8-8h16a2 2 0 0 1 2 2v32a2 2 0 0 1-2 2H40a8 8 0 0 0-8 8M6 48a2 2 0 0 0 2 2h16a8 8 0 0 1 8 8V22a8 8 0 0 0-8-8H8a2 2 0 0 0-2 2v32Z",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIcon0;